import React from 'react';
import { Card, Layout, Menu, Space, Typography } from 'antd';
import './InternalLayout.css';

const { Content, Sider } = Layout;
const { Paragraph, Title } = Typography;

const InternalLayout = ({
  title,
  description,
  navItems = [],
  activeKey,
  onNavChange,
  actions,
  children,
}) => {
  const hasNav = navItems.length > 0;

  const handleMenuClick = ({ key }) => {
    if (onNavChange) {
      onNavChange(key);
    }
  };

  return (
    <div className="internal-layout">
      <Layout>
        {hasNav && (
          <Sider className="internal-layout-sider" width={224} theme="light">
            <Menu
              mode="inline"
              selectedKeys={activeKey ? [activeKey] : []}
              items={navItems}
              onClick={handleMenuClick}
            />
          </Sider>
        )}

        <Content className="internal-layout-content">
          <div className="internal-layout-inner">
            <Card className="internal-layout-header-card">
              <div className="internal-layout-header">
                <div>
                  <Title level={1}>{title}</Title>
                  {description && <Paragraph>{description}</Paragraph>}
                </div>
                {actions && (
                  <Space className="internal-layout-actions" size={[8, 8]} wrap>
                    {actions}
                  </Space>
                )}
              </div>
            </Card>

            {hasNav && (
              <Card className="internal-layout-mobile-menu">
                <Menu
                  mode="horizontal"
                  selectedKeys={activeKey ? [activeKey] : []}
                  items={navItems}
                  onClick={handleMenuClick}
                />
              </Card>
            )}

            <div className="internal-layout-body">
              {children}
            </div>
          </div>
        </Content>
      </Layout>
    </div>
  );
};

export default InternalLayout;
